import { useMutation, useQueryClient } from '@tanstack/react-query';
import { schedulingApi, type CreateAppointmentData } from '@/api';

const APPOINTMENTS_KEY = 'appointments';
const PAYMENTS_KEY = 'payments';

export type ServiceType = 'TELEMEDICINA' | 'DOMICILIAR' | 'PRESENCIAL';
export type { CreateAppointmentData };

export function useCreateAppointment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateAppointmentData) => schedulingApi.createAppointment(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [APPOINTMENTS_KEY] });
      queryClient.invalidateQueries({ queryKey: ['doctor'] });
      queryClient.invalidateQueries({ queryKey: [PAYMENTS_KEY] });
    },
  });
}
